// Button Expanded
export const ExpandedBtn = (() => {
	const toggleVisibility = (btns) => {
		btns.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				[].forEach.call(btns, (sib) => {
					sib.classList.remove("is-expanded");
				});
				e.currentTarget.classList.toggle("is-expanded");
			});
		});
	};
	const init = () => {
		let btnsExpanded = document.querySelectorAll(".expanded-btn");
		toggleVisibility(btnsExpanded);

		document.addEventListener("click", function (event) {
			const isOutside = !event.target.closest(".expanded-btn");
			if (isOutside) {
				btnsExpanded.forEach((el) => {
					el.classList.remove("is-expanded");
				});
			}
		});
	};

	return {
		init: init,
	};
})();
